export const education_academic = [
  { char: '🎓', name: 'Graduation Cap', nameZh: '畢業/學位', keywords: ['school', 'graduate', 'learn', '學位'], hot: true },
  { char: '🏫', name: 'School', nameZh: '校園', keywords: ['education', 'study', 'campus'] },
  { char: '📚', name: 'Books', nameZh: '圖書館/知識', keywords: ['read', 'study', 'learn', '書'], hot: true },
  { char: '📝', name: 'Memo', nameZh: '筆記/測驗', keywords: ['write', 'exam', 'note'] },
  { char: '🔬', name: 'Microscope', nameZh: '研究/實驗室', keywords: ['science', 'lab', 'research'] },
  { char: '🔭', name: 'Telescope', nameZh: '探索/天文', keywords: ['space', 'science', 'discover'] },
  { char: '🧪', name: 'Test Tube', nameZh: '化學/研發', keywords: ['science', 'lab', 'tech'] },
  { char: '📐', name: 'Triangular Ruler', nameZh: '工程/設計', keywords: ['math', 'design', 'ruler'] },
  { char: '📒', name: 'Ledger', nameZh: '課程講義', keywords: ['note', 'school', 'learn'] },
  { char: '🎒', name: 'Backpack', nameZh: '開學/書包', keywords: ['school', 'child', 'start'] },
  { char: '🧠', name: 'Brain', nameZh: '腦力/思維', keywords: ['think', 'smart', 'idea'], hot: true },
  { char: '🏫', name: 'School', nameZh: '教育機構', keywords: ['building', 'education'] },
];